'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$23() {
  this.bgQ = null;
  this.bgO = null;
  this.bgP = false;
  this.bgM = null;
  this.bgN = false;
  this.bgR = false;
  this.bgS = false;
  this.bgQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$23 as $c_Lpresto_PrestoRouter$$anon$23 };
$p = $c_Lpresto_PrestoRouter$$anon$23.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$23;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$23() {
}
export { $h_Lpresto_PrestoRouter$$anon$23 as $h_Lpresto_PrestoRouter$$anon$23 };
$h_Lpresto_PrestoRouter$$anon$23.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bgQ;
});
$p.t = (function() {
  if ((!this.bgP)) {
    this.bgO = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bgP = true;
  }
  return this.bgO;
});
$p.ag = (function() {
  if ((!this.bgN)) {
    this.bgM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bgN = true;
  }
  return this.bgM;
});
$p.v = (function() {
  if ((!this.bgS)) {
    this.bgR = false;
    this.bgS = true;
  }
  return this.bgR;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$23 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$23, "presto.PrestoRouter$$anon$23", ({
  NW: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$23 as $d_Lpresto_PrestoRouter$$anon$23 };
//# sourceMappingURL=presto.-Presto-Router$$anon$23.js.map
